<div class="calendar-container">
    <div class="calendar-header">
      <div class="left-controls">
        <div class="month-year-selector">

          <span *ngIf="selectedModule !== 'Day'" class="month-year-text"   
            [ngClass]="{'mview': selectedModule === 'Month', 'wview': selectedModule === 'Week'}">{{ currentMonthYear }}</span>
          <span *ngIf="selectedModule === 'Day'" class="month-year-text dview">{{ selectedDate | date: 'MMMM d, y' }}</span>

          <div class="arrows">
            <button (click)="navigate(1)" class="arraBtn"> <i class="bi bi-caret-up-fill"></i> </button>
            <button (click)="navigate(-1)" class="arraBtn"> <i class="bi bi-caret-down-fill"></i> </button>
          </div>          
        </div>
        <button class="today-btn" (click)="goToToday()">Today</button>
      </div>
  
      <div class="right-controls">
        <select class="view-select" [(ngModel)]="selectedModule" (change)="onModuleChange()">
          <option *ngFor="let module of modules" [value]="module">{{ module }}</option>
        </select>
        <button class="create-event-btn" (click)="onAddCalendar()">+ Create Event</button>
      </div>
    </div>
  
    <!-- Month View -->
    <div *ngIf="selectedModule === 'Month'" class="calendar-grid">
      <div class="day-label" *ngFor="let day of ['SUN','MON','TUE','WED','THU','FRI','SAT']">{{ day }}</div>
      <!-- <ng-container *ngFor="let date of calendarDates">
        <div class="calendar-cell"
          [class.other-month]="date.otherMonth"
          [class.today]="date.isToday">
          {{ date.day }}
          
        </div>
      </ng-container> -->
      <!-- <ng-container *ngFor="let date of calendarDates">
        <div class="calendar-cell" [class.other-month]="date.otherMonth" [class.today]="date.isToday">
          <div class="date-number">{{ date.day }}</div>
          
          <div *ngFor="let event of getMonthEvents(date.fullDate)" class="event-title" (click)="onEditCalendar(event)">
            {{ event.from_ts | date: 'shortTime' }} - {{ event.title }}
          </div>
        </div>
      </ng-container> -->
      <ng-container *ngFor="let date of calendarDates">
        <div class="calendar-cell" style="border: 1px solid #ccc;border-radius: 0 !important;" 
        [class.other-month]="date.otherMonth" [class.today]="date.isToday"
        [class.saturday]="isSaturday(date.fullDate)" [class.sunday]="isSunday(date.fullDate)">
          <div class="date-number" [class.todays]="date.isToday">{{ date.day }}</div>
          <!-- All-Day Events -->
          <div *ngFor="let event of getAllDayEvents(date.fullDate)" class="event-title" (click)="onEditCalendar(event)">
             {{ event.title }}
          </div>
          <!-- Timed Events -->
          <div *ngFor="let event of getMonthEvents(date.fullDate)" class="event-title" (click)="onEditCalendar(event)">
             {{ event.from_ts | date: 'shortTime' }} - {{ event.title }}
          </div>
        </div>
      </ng-container>
    </div>
  
    <!-- Week View -->
    <div *ngIf="selectedModule === 'Week'" class="week-grid">
      <div class="week-columns">
        <!-- Time Column -->
        <div class="time-labels time-labels2">
          <!-- <div class="all-day-bar">
            <div class="time-label2">all-day</div>
          </div> -->
    
          <div class="gmt-label">+ GMT+5</div>
          <div class="timeH" *ngFor="let hour of hours">{{ hour }}</div>
        </div>
        <!-- Week Columns -->
        <div class="week-column" *ngFor="let date of calendarDates" [class.today-column]="date.isToday">
    
          <!-- Timeline Indicator - week -->
          <div class="current-time-indicator" *ngIf="date.isToday" [style.top.px]="currentTimePosition">
            <span class="dot"></span>
            <div class="line"></div>
          </div>
          <!-- Timeline Indicator - week -->

          <!-- Day Header -->
          <div class="week-header" [class.today-header]="date.isToday">
            <span class="week-name">{{ date.fullDate | date: 'EEE' }}</span>
            <span class="week-number">{{ date.fullDate | date: 'd' }}</span>
          </div>
    
          <!-- All Day Events Section -->
          <div class="all-day-bar hegh">
            <!-- <div class="time-label"></div> -->
            <div class="all-day-events-container">
              <div class="all-day-event" style="width: auto;" *ngFor="let event of getAllDayEvents(date.fullDate)"
                (click)="onEditCalendar(event)">
                {{ event.title }}
              </div>
            </div>
          </div>
    
          <!-- Timed Events -->
          <!-- <div class="hour-cell" *ngFor="let hour of hours">
            <div *ngFor="let event of getWeekEvents(date.fullDate, hour)" class="event-title"
              (click)="onEditCalendar(event)" [ngStyle]="getEventStyle(event)">
              {{ event.from_ts | date: 'shortTime' }} - {{ event.title }}
            </div>
          </div> -->

          <div class="hour-cell" *ngFor="let hour of hours">
            <div *ngFor="let event of getWeekEvents(date.fullDate, hour)" class="event-title et2" (click)="onEditCalendar(event)"
              [ngStyle]="{
                   left: 'calc(' + (event.column * event.width) + '% + 0px)',
                    width: 'calc(' + event.width + '% + 0px)',
                    height: getEventHeight(event) + 'px',
                    padding: '5px',
                    'z-index': 10
                 }">
              {{ event.from_ts | date: 'shortTime' }} - {{ event.title }}
            </div>
          </div>

          <!-- Current Time Indicator -->
          <!-- <div *ngIf="date.isToday" class="current-time-indicator" [ngStyle]="{ top: currentTimePosition + 'px' }">
            <span class="dot"></span>
            <div class="line"></div>
          </div> -->
    
        </div>
      </div>
    </div>

    <!-- Day View -->
    <div *ngIf="selectedModule === 'Day'" class="day-grid">
        <div class="day-header">
        <div class="day-name">{{ selectedDate | date: 'EEEE' }}</div>
        <div class="day-number">{{ selectedDate | date: 'd' }}</div>
        </div>
    
        <!-- All Day Events Section -->
        <div class="all-day-bar" *ngIf="allDayEvents.length > 0">
          <div class="time-label">all-day</div>
          <div class="all-day-events-container">
            <div class="all-day-event" *ngFor="let event of allDayEvents" (click)="onEditCalendar(event)">
              {{ event.title }}
            </div>
          </div>
        </div>

        <div class="day-view-grid">
        <div class="time-column">
            <div *ngFor="let hour of hoursDay" class="hour-label">{{ hour }}</div>
        </div>
    
        <!-- Right: Day Column with Time Slots and Events -->
        <div class="events-column">
            <div class="hour-slot" *ngFor="let hour of hoursDay"></div>
    
            <!-- Current time indicator -->
            <!-- <div class="current-time-indicator" [ngStyle]="{ top: currentTimePosition + 'px' }">
            <span class="dot"></span>
            <div class="line"></div>
            </div> -->
    
            <!-- Timeline Indicator - week -->
            <div class="current-time-indicator" [style.top.px]="currentTimePosition">
              <span class="dot"></span>
              <div class="line"></div>
            </div>
            <!-- Timeline Indicator - week -->


            <!-- Dynamic Events -->
            <!-- <div class="event-block" *ngFor="let event of dayEvents" (click)="onEditCalendar(event)" [ngStyle]="getEventStyle(event)">
            <div class="event-title" style="background-color: transparent !important;"> {{ event.from_ts | date: 'shortTime' }} - {{ event.title }}</div>
            <!-- <div class="event-time">{{ event.startTime }} - {{ event.endTime }}</div> --
            </div> -->

            <div class="event-block" *ngFor="let event of dayEvents" (click)="onEditCalendar(event)" 
            [ngStyle]="{top: (event.startHour * hourHeight + (event.startMinute / 60) * hourHeight) + 'px',
                        height: (event.duration * hourHeight) + 'px',
                        left: (event.column * event.width) + '%',
                        width: event.width + '%'}">
              <div class="event-title">{{ event.from_ts | date:'shortTime' }} - {{ event.title }}</div>
            </div>

        </div>
        </div>
    </div>
  
</div>
  